import { useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { groceryActions } from "../../store/grocery-slice";
import Button from "../UI/Button/Button";
import classes from "./BuyAgainList.module.css";

const SORT_OPTIONS = {
  MOST_PURCHASED: "most-purchased",
  RECENTLY_PURCHASED: "recently-purchased",
  ALPHABETICAL: "alphabetical",
};

const BuyAgainList = (props) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState(SORT_OPTIONS.RECENTLY_PURCHASED);
  const dispatch = useDispatch();

  const displayedItems = useMemo(() => {
    const normalizedSearchTerm = searchTerm.trim().toLowerCase();
    const filteredItems = props.items.filter((item) =>
      item.title.toLowerCase().includes(normalizedSearchTerm)
    );

    return [...filteredItems].sort((firstItem, secondItem) => {
      if (sortBy === SORT_OPTIONS.MOST_PURCHASED) {
        const purchaseDifference =
          (secondItem.previousPurchases ?? 0) -
          (firstItem.previousPurchases ?? 0);

        if (purchaseDifference !== 0) {
          return purchaseDifference;
        }
      }

      if (sortBy === SORT_OPTIONS.RECENTLY_PURCHASED) {
        const firstDate = firstItem.lastPurchasedDate
          ? new Date(firstItem.lastPurchasedDate).getTime()
          : 0;
        const secondDate = secondItem.lastPurchasedDate
          ? new Date(secondItem.lastPurchasedDate).getTime()
          : 0;
        const dateDifference = secondDate - firstDate;

        if (dateDifference !== 0) {
          return dateDifference;
        }
      }

      return firstItem.title.localeCompare(secondItem.title);
    });
  }, [props.items, searchTerm, sortBy]);

  const addToListHandler = (buyAgainItem) => {
    dispatch(groceryActions.buyItemAgain(buyAgainItem));
  };

  return (
    <>
      <h2 className={classes.title}>Previously Purchased Items:</h2>
      {props.items.length === 0 ? (
        <p className={classes.message}>No previous purchases found.</p>
      ) : (
        <>
          <div className={classes.controls}>
            <label className={classes.field}>
              <span>Search</span>
              <input
                type="search"
                value={searchTerm}
                onChange={(event) => setSearchTerm(event.target.value)}
              />
            </label>
            <label className={classes.field}>
              <span>Sort</span>
              <select
                value={sortBy}
                onChange={(event) => setSortBy(event.target.value)}
              >
                <option value={SORT_OPTIONS.RECENTLY_PURCHASED}>
                  Recently purchased
                </option>
                <option value={SORT_OPTIONS.MOST_PURCHASED}>
                  Most purchased
                </option>
                <option value={SORT_OPTIONS.ALPHABETICAL}>Alphabetical</option>
              </select>
            </label>
          </div>
          {displayedItems.length === 0 ? (
            <p className={classes.message}>No matching purchases found.</p>
          ) : (
            <div className={classes["purchased-list"]}>
              {displayedItems.map((grocery) => (
                <Button
                  key={grocery.id}
                  className={classes["purchased-item"]}
                  onClick={() => addToListHandler(grocery)}
                >
                  <span>{grocery.title}</span>
                  <small>{grocery.previousPurchases ?? 0} bought</small>
                </Button>
              ))}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default BuyAgainList;
